import React, { useState } from 'react';

const CaseStudiesPartnerParagraph = (props) => {
  const [readMore, setReadMore] = useState(false);
  let partnerTxtBlock;
  if (props.article && Object.keys(props.article).length > 1) {
    partnerTxtBlock = Object.keys(props.article).map((key) => {
      return (
        <div key={key} className="column">
          {props.article[key].map((paragraph, key) => {
            return (
              <p key={key} dangerouslySetInnerHTML={{__html: paragraph}} />
            )
          })}
        </div>
      )      
    })
  } else {
    partnerTxtBlock = props.article["column"].map((paragraph, key) => {
      return (
        <p key={key} dangerouslySetInnerHTML={{__html: paragraph}} />
      )
    })
  }
  
  return (
    <div className="row case-paragraph">
      <div className="col-md-10 col-md-offset-1 col-xs-12">
        <div className={`read-more-txt ${readMore ? 'expanded' : 'collapsed'} ${Object.keys(props.article).length > 1 ? 'columns' : ''}`}>
          {partnerTxtBlock}
          <div className="mask"></div>
        </div>
        <div className="mobile-read-more-btn text-center">
          <button className={`${!readMore ? 'read-more-btn' : 'read-more-btn reverse'}`} onClick={() => setReadMore(!readMore)}>{!readMore ? 'Read more' : 'Read less'}</button>
        </div>
      </div>
    </div>
  )
}

export default CaseStudiesPartnerParagraph


// WEBPACK FOOTER //
// ./resources/assets/js/caseStudies/CaseStudiesPartnerParagraph.js